<app-note-add
  [partnerObject]="partnerObject"
  [ofwcaObject]="ofwcaObject"
  (noteCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
></app-note-add>
